(function () {
    "use strict";

    angular
        .module("FormBuilder")
        .directive("fbFieldDatatableToggleManager", fbFieldDatatableToggleDirective);

    function fbFieldDatatableToggleDirective(lodash, FormBuilderService) {
        return {
            restrict: "E",
            scope: {
                element: "="
            },
            require: "ngModel",
            templateUrl: "common/libraries/formBuilder/fields/fieldDatatableToggleManager",
            link: fbFieldDatatableToggleManagerDirectiveLink,
            controller: fbFieldDatatableToggleManagerDirectiveCtrl
        };

        function fbFieldDatatableToggleManagerDirectiveLink(scope, elem, attr, ctrl) {
            scope.currentScope = {
                element: scope.element
            };

            ctrl.$render = function () {
                scope.currentScopeModel = ctrl.$modelValue;
            };

            scope.$watch("currentScopeModel", function () {
                ctrl.$setViewValue(scope.currentScopeModel);
            });
        }

        function fbFieldDatatableToggleManagerDirectiveCtrl($scope, lodash) {
            var formIdentifier = '';
            var elementIdentifier = '';
            var fbService = null;

            this.$onInit = function() {
                formIdentifier = $scope.$parent.vm.formIdentifier;
                elementIdentifier = $scope.$parent.vm.elementIdentifier;
                fbService = FormBuilderService.get(formIdentifier);

                $scope.events = {
                    hasError: hasError,
                    errorMessage: errorMessage
                };
            }

            function hasError($index) {
                return !lodash.isEmpty(
                    fbService.elementsService.getValidationRule(elementIdentifier)
                );

                // return !lodash.isEmpty(
                //     fbService.elementsService.getValidationRule(elementIdentifier + '[' + $index + ']')
                // );
            }

            function errorMessage() {
                var error = fbService.elementsService.getValidationRule(elementIdentifier);
                if (!error) {
                    return '';
                }
                return error.join(' ');

                // var error = fbService.elementsService.getValidationRule(
                //     elementIdentifier
                // );
                // var format = {};
                // if (error) {
                //     Object.keys(error).forEach(function (key) {
                //         format[key] = lodash.flatMap(error[key]).join(" ");
                //     });
                // }
                // return format;
            }
        }
    }
})();
